import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../hooks/useStore';
import { DataViewEditBox, Loading } from '../../../lib/components';
import { format } from 'date-fns';

import { DataView } from './shared/view';
import { FC } from 'react';
import { useCompanyBenefitSettingsData } from '../../../queries/company';
import { Box } from '@mui/material';

type Props = {
  onPendingChanges?: (changes: Record<string, string>) => void;
};

export const CompanyJobbikeSettings: FC<Props> = observer((props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { data: benefitSettingsData, isLoading } = useCompanyBenefitSettingsData(
    companyStore.company?.id ?? ''
  );
  const settingsData = {
    activation_mail_receiver: benefitSettingsData?.jobbike.activation_mail_receiver ?? ''
  };

  const contractData = {
    main_partner: benefitSettingsData?.jobbike?.main_partner ?? '',
    customer_number: benefitSettingsData?.jobbike?.customer_number ?? '',
    contract_number: benefitSettingsData?.jobbike?.contract_number ?? '',
    contact_name: [
      benefitSettingsData?.jobbike?.advisor?.first_name,
      benefitSettingsData?.jobbike?.advisor?.last_name
    ]
      .filter(Boolean)
      .join(' '),
    contact_mail: benefitSettingsData?.jobbike?.advisor?.contact_mail ?? '',
    contact_number: benefitSettingsData?.jobbike?.advisor?.contact_number ?? '',
    contract_start: benefitSettingsData?.jobbike?.contract_start
      ? format(new Date(benefitSettingsData?.jobbike?.contract_start), 'dd.MM.yyyy')
      : '',
    contract_end: benefitSettingsData?.jobbike?.contract_end
      ? format(new Date(benefitSettingsData?.jobbike?.contract_end), 'dd.MM.yyyy')
      : '',
    admin_portal: benefitSettingsData?.jobbike?.admin_portal ?? '',
    employee_portal: benefitSettingsData?.jobbike?.employee_portal ?? ''
  };

  const contract_document = benefitSettingsData?.jobbike?.contract_document ?? undefined;

  const renderView = observer(() => (
    <DataView
      benefit="jobbike"
      settingsData={settingsData}
      contractData={contractData}
      contract={contract_document}
      onPendingChanges={props.onPendingChanges}
    />
  ));

  const renderEdit = () => <></>;
  return isLoading ? (
    <Box className="w-[950px] mt-20">
      <Loading />
    </Box>
  ) : (
    <DataViewEditBox
      title={t('common:JOBBIKE')}
      view={renderView}
      edit={renderEdit}
      canEdit={false}
      canSubmit={false}
    />
  );
});
